import {
  GET_ALL_PURCHASES_SUCCESS,
  GET_PURCHASE_SUCCESS,
  GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILURE, GET_PRODUCTS, GET_GUIDELINE_SUCCESS
} from '../actions/purchases'

const INITIAL_STATE = {
  availableProducts: null,
  error: null,
  loading: false,
  purchasedProducts: [],
  guidelineProduct: null
}

const purchases = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        availableProducts: null,
        error: null,
        loading: true,
      }
    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        availableProducts: action.payload,
        error: null,
        loading: false
      }
    case GET_PRODUCTS_FAILURE:
      return {
        ...state,
        availableProducts: null,
        error: action.payload,
        loading: false
      }

    case GET_ALL_PURCHASES_SUCCESS:
      return {
        ...state,
        purchasedProducts: action.payload,
        error: null,
        loading: false
      }

    case GET_PURCHASE_SUCCESS:
      return {
        ...state,
        guidelineProduct: action.payload,
        error: null,
        loading: false
      }

    case GET_GUIDELINE_SUCCESS:
      return {
        ...state,
        guidelineProduct: action.payload,
        error: null,
        loading: false
      }

    default:
      return state
  }
}

export default purchases



// WEBPACK FOOTER //
// ./src/reducers/Purchases.js